import { AfterViewInit, Component, Inject, Renderer2 } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService, MsalBroadcastService } from "@azure/msal-angular";

import { Subject, filter, firstValueFrom, takeUntil } from "rxjs";
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from "@azure/msal-browser";

import { MsalAuthService } from "./shared/msal/msal-auth.service";
import { coreComponents } from "./shared/exports";
import { RouteGuardService } from "./shared/services/route-guard.service";
import { UserService } from "./shared/services/user.service";
import { IUserDetails } from "./shared/search/typings";
import { InfoService } from "./shared/info/info.service";
import { Info } from "./shared/info/typings";
import { FooterService } from "./shared/footer/footer.service";
import { DOCUMENT } from "@angular/common";

 
type ProfileType = {
  displayName?: string,
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string,
  jobTitle?: string,
  mail?: string,
  mobilePhone?: string,
  officeLocation?: string,
  initials?: string
};
 
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ...coreComponents],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit {
  title = "Ecode 2.0";
  isIframe = false;
  isUserLoggedIn = false;
  loginDisplay = false;
  isPopupDisplayed = false;
  private readonly _destroying$ = new Subject<void>();
  showCategoriesAndFooter: boolean = true;
  userDetails: IUserDetails;
  infoData: Info;
  footerData: string 
  nonceValue: any;
 
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,    
    private router: Router,
    private authenService: MsalAuthService,
    private routeGuardService: RouteGuardService,
    private userService: UserService,
    private infoService: InfoService,
    private footerService: FooterService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  ngAfterViewInit() {
    this.handleNonce();
  }

  handleNonce() {
    fetch(window.location.origin + "/assets/config.js").then((res) => {
      this.nonceValue = res.headers.get("x-csp-nonce");
      if (this.nonceValue) {
        const scripts = this.document.querySelectorAll('script');
        scripts.forEach(script => {
          this.renderer.setAttribute(script, 'nonce', this.nonceValue);
        });

        const styleTag = this.document.querySelectorAll('style');
        styleTag.forEach(script => {
          this.renderer.setAttribute(script, 'nonce', this.nonceValue);
        });
      } else {
        console.log("App component nonce not found in header response");
      }
    });
  }
 
  async ngOnInit(): Promise<void> {    
    this.shouldShowCategoriesAndFooter();

    this.isIframe = window !== window.parent && !window.opener;
 
     var token = await firstValueFrom(this.authService.handleRedirectObservable());
    if (token  != null) {
      this.isUserLoggedIn=true;
      this.authenService.setToken(token );
      console.log(token , "loginRedirect");
    }
    if (this.authenService.isTokenExpired()) {
     token = await this.getTokenDetails();
      if (token != null) {
        this.isUserLoggedIn=true;
        this.authenService.setToken(token);
      }
    }
   
    this.userService.getUseDetails().subscribe({
      next: (user) => {
        this.userService.setUserDetails(user);
        this.userDetails = user; // Store user information             
      },
      error: (err) => {
        console.error('Error fetching user details:', err);
      }
    });    

      //get Info Data
      this.getInfoData();

      //get footer Data
      this.getFooterData();

    await this.setEmployeeDetailsIfNotFoundInSession(token);
    await this.checkTokenExpiry();

  }

  private getFooterData(): void {
    this.footerService.getData().subscribe({
      next: (response) => {
        const footerHtml = response?.[0]?.htmlContent || '';
        this.footerData = footerHtml; // Assign the fetched footer data
        
      },
      error: (err) => {
        console.error('Error fetching footer data:', err);
      }
    });
  }

  private getInfoData(): void {
    this.infoService.getInfoData().subscribe({
      next: (data: Info) => {
        this.infoData = data; // Assign the fetched data          
      },
      error: (err) => {
        console.error('Error fetching info data:', err);
      }
    });
  }
 
  async setEmployeeDetailsIfNotFoundInSession(token:any): Promise<void> {
      if(token!=null) {
        var loggedinEmail = token.account.username;    
      }
      else {
        this.authenService.login();
      }    
  }
 
 async checkTokenExpiry(): Promise<void> {
    setInterval(async () => {
      if (this.authenService.isTokenExpired()) {
          await this.showTokenExpiredPopup();
      }
    }, 60000); // Check every minute
  }
 
  async showTokenExpiredPopup(): Promise<void> {
    // Logic to show a popup
    alert('Your session has expired. Please click ok to refresh token.');
    var token = await this.getTokenDetails();
    if (token != null) {
      this.authenService.setToken(token);
    }
  }
 
  private async getTokenDetails(): Promise<any> {    
    return await this.authenService.saveAndGetTokenInSession();
  }   
 

  shouldShowCategoriesAndFooter() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showCategoriesAndFooter = this.routeGuardService.shouldShowComponent();
      }
    });
   }

  // unsubscribe to events when component is destroyed
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

}
 
